export default __webpack_public_path__ + "static/media/grafema_gim-tonico_06.6313fbb5.jpg";